import Helpers from "../../helpers/helpers";
import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    let isRemember = localStorage.getItem("remember");
    let token = JSON.parse(localStorage.getItem("token"))

    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
        };
        return requestOptions
    }

}

export const salesReportListing = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}sales-report?sort_by=${payload?.sort || ''}&sort_order=${payload?.sort_order || ''}&paginate=${payload?.page}&size=${payload?.length || ''}${payload?.status ? `&filter[status]=${payload?.status}` : ''}${payload?.from_date ? `&filter[created_date_from]=${payload?.from_date}` : ''}${payload?.to_date ? `&filter[created_date_to]=${payload?.to_date}` : ''}${payload?.platform ? `&filter[sales_platform]=${payload?.platform}` : ''}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const exportSalesReportApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}sales-report/export?sort_by=${payload?.sort || ''}&sort_order=${payload?.sort_order || ''}${payload?.status ? `&filter[status]=${payload?.status}` : ''}${payload?.created_date_from ? `&filter[created_date_from]=${payload?.created_date_from}` : ''}${payload?.created_date_to ? `&filter[created_date_to]=${payload?.created_date_to}` : ''}${payload?.sales_platform ? `&filter[sales_platform]=${payload?.sales_platform}` : ''}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const customerReportListing = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}customer-report?sort_by=${payload?.sort_by || ''}&sort_order=${payload?.sort || ''}&paginate=${payload?.page}&size=${payload?.length || ''}&filter[status]=${payload?.status || ''}&filter[created_date_from]=${payload?.from_date || ''}&filter[created_date_to]=${payload?.to_date || ''}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const exportCustomerReportApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}customer-report/export?sort_by=${payload?.sort || ''}&sort_order=${payload?.sort_order || ''}${payload?.status ? `&filter[status]=${payload?.status}` : ''}${payload?.created_date_from ? `&filter[created_date_from]=${payload?.created_date_from}` : ''}${payload?.created_date_to ? `&filter[created_date_to]=${payload?.created_date_to}` : ''}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const productSalesReportListingApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}product-report?sort_by=${payload?.sort || ''}&sort_order=${payload?.sort_by || ''}&paginate=${payload?.page}&size=${payload?.length || ''}${payload?.status ? `&filter[status]=${payload?.status}` : ''}${payload?.from_date ? `&filter[created_date_from]=${payload?.from_date}` : ''}${payload?.to_date ? `&filter[created_date_to]=${payload?.to_date}` : ''}${payload?.platform ? `&filter[sales_platform]=${payload?.platform}` : ''}${payload?.category ? `&filter[category_id]=${payload?.category}` : ''}${payload?.manufacturer ? `&filter[manufacturer_id]=${payload?.manufacturer}` : ''}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const exportProductSalesReportApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}product-report/export?sort_by=${payload.sort}&sort_order=${payload.sort_order}${payload?.status ? `&filter[status]=${payload?.status}` : ''}${payload?.created_date_from ? `&filter[created_date_from]=${payload?.created_date_from}` : ''}${payload?.created_date_to ? `&filter[created_date_to]=${payload?.created_date_to}` : ''}${payload?.sales_platform ? `&filter[sales_platform]=${payload?.sales_platform}` : ''}${payload?.category_id ? `&filter[category_id]=${payload?.category_id}` : ''}${payload?.manufacturer_id ? `&filter[manufacturer_id]=${payload?.manufacturer_id}` : ''}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const categorySalesReportApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}category-report?sort_by=${payload.sort}&sort_order=${payload.sort_order}&paginate=${payload?.page}&size=${payload?.length || ''}&filter[sales_platform]=${payload.sales_platform}&filter[created_date_from]=${payload.created_date_from}&filter[created_date_to]=${payload.created_date_to}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const exportCategorySalesReportApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}category-report/export?sort_by=${payload.sort_by}&sort_order=${payload.sort_order}${payload?.filter ? `&filter[sales_platform]=${payload?.filter?.sales_platform || ""}&filter[created_date_from]=${payload?.filter?.created_date_from || ""}&filter[created_date_to]=${payload?.filter?.created_date_to || ""}` : ""}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const marketingSalesReportApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}marketing-report?sort_by=${payload.sort}&sort_order=${payload.sort_order}&paginate=${payload?.page}&size=${payload?.length || ''}${payload?.status ? `&filter[status]=${payload.status}` : ""}${payload?.type ? `&filter[type]=${payload.type}` : ""}${payload?.discount_type ? `&filter[discount_type]=${payload.discount_type}` : ""}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const exportMarketingSalesReportApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}marketing-report/export?sort_by=${payload.sort_by}&sort_order=${payload.sort_order}${payload?.filter ? `${payload?.filter?.status ? `&filter[status]=${payload?.filter?.status || ""}` : ""}${payload?.filter?.type ? `&filter[type]=${payload?.filter?.type || ""}` : ""}${payload?.filter?.discount_type ? `&filter[discount_type]=${payload?.filter?.discount_type || ""}` : ""}` : ""}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({code: "network_error", message: "Network response error, please try again later"});
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};